import Vue from 'vue';
import Config from '@/config';

const mutations = {
    commentCreate: (state, payload) => {
        console.log("MUTATION comment/create", payload);
        if (!payload.taskId) return;

        // after creation - refresh msg list
        payload.mutation = "commentAppend";
        //payload.action = "task/msgs";
        /*payload.broadcast = {
            entity: "task",
            taskId: payload.task?.id,
        };*/
    },
    commentAppend: (state, payload) => {
        console.log("MUTATION comment/append", payload);

        let taskId;
        if (payload.commentAppend?.item) {
            // mutation with append only
            taskId = payload.commentAppend.item.taskId;
            if (state.page.task.item?.id === taskId) {
                if (!state.page.comments.items) Vue.set(state.page.comments, "items", []);
                state.page.comments.items.push(payload.commentAppend.item);
            }
        }
        /*else if ( payload?.msg?.item.todoId ) {
            // todo this should not be done with task - use first type

            // mutation with task
            taskId = payload?.msg?.item.todoId;
            // 0. currently edited task is updated in setState automatically

            // 1. refresh msgs of current task
            // are we in needed task?
            //console.log("taskId", taskId);
            //console.log("state.page.task.item.id", state.page.task.item?.id);
            if (state.page.task.item?.id === taskId) {
                state.page.comments.items = payload.comments.items;
            }

            // 3. update task in current context
            if ( payload.task?.item ) {
                const items = state.page.tasks.items;
                if (items?.length) {
                    const update = (item) => {
                        Object.keys(payload.task?.item).forEach(key => {
                            Vue.set(item, key, payload.task?.item[key]);
                        })
                    }

                    const item = items.find(el => el.id === payload.task.item.id);
                    if (item) update(item);
                }
            }
        }*/
    },

    /**
     * This does not broadcast.
     * @param state
     * @param payload
     */
    commentSetUploads: (state, payload) => {
        console.log("MUTATION comment/setUploads", payload);
        if (!payload) return;

        Vue.set(state.page.comment, "uploads", payload);
    },
};

export default mutations;
